import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsIssuesPrioritiesRoute } from '@atlassian/jira-router-routes-admin-pages-priorities-routes/src/globalSettingsIssuesPrioritiesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import PrioritiesPage, {
	LazyPrioritiesPage,
} from './ui/spa/admin-pages/priorities/issue-priorities/index.tsx';

export const globalSettingsIssuesPrioritiesRouteEntry = createEntry(
	globalSettingsIssuesPrioritiesRoute,
	() => ({
		group: 'global-settings',
		component: PrioritiesPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyPrioritiesPage],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-priorities-entries/src/globalSettingsIssuesPrioritiesRouteEntry.tsx',
				whichExportToUse: 'globalSettingsIssuesPrioritiesRouteEntry',
			},

			enabled: true,
		},
	}),
);
